import React from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  width: 100%;
  max-width: 420px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  @media (max-width: 480px) {
    padding: 1.25rem;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

const ModalTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  @media (max-width: 480px) {
    font-size: 1.1rem;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: all 0.2s ease;
  &:hover {
    background: #f3f4f6;
    color: #374151;
  }
`;

const BodyText = styled.p`
  font-size: 0.9375rem;
  line-height: 1.6;
  color: #4b5563;
  margin: 0;
  @media (max-width: 480px) {
    font-size: 0.875rem;
  }
`;

const HOME_COPY = (
  <>
    You are responsible for organising this match coordinate with opponents (e.g. match chat), agree date/time, find and book the court, notify the other team.
  </>
);

const AWAY_COPY = (
  <>
    Your opponents are responsible for organising this match they coordinate, book the court, and notify you; you respond and show up.
  </>
);

export default function HomeAwayInfoModal({ isOpen, onClose, type }) {
  if (!isOpen) return null;
  const isHome = type === 'home';
  const title = isHome ? '🏠 Home' : '✈️ Away';
  const copy = isHome ? HOME_COPY : AWAY_COPY;

  return (
    <ModalOverlay onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="home-away-modal-title">
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle id="home-away-modal-title">{title}</ModalTitle>
          <CloseButton type="button" onClick={onClose} aria-label="Close">&times;</CloseButton>
        </ModalHeader>
        <BodyText>{copy}</BodyText>
      </ModalContent>
    </ModalOverlay>
  );
}
